// extracted by mini-css-extract-plugin
export default {"root":"top-switcher_root__uNzIR","elem":"top-switcher_elem__FEfhf","active":"top-switcher_active__M9Cla"};